<template>
  <div>
    <el-row>
      <el-col>
        <h4 class="h4">
          <i class="el-icon-s-management"></i>&nbsp;&nbsp;{{ $t('preprint.submitAuthor.title') }}
        </h4>
      </el-col>

      <el-form
        v-for="(author, index) in authors"
        :key="index"
        ref="authors"
        label-width="120px"
        class="demo-dynamic"
      >
        <el-form-item
          :label="$t('preprint.submitAuthor.authorLabel') + (index + 1)"
          :prop="'authors.' + index + '.authorName'"
        >
          <el-input
            v-model="author.authorName"
            :placeholder="$t('preprint.submitAuthor.authorNamePlaceholder')"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('preprint.submitAuthor.emailLabel')" prop="authorEmail">
          <el-input
            v-model="author.authorEmail"
            :placeholder="$t('preprint.submitAuthor.emailPlaceholder')"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('preprint.submitAuthor.affiliationLabel')" prop="authorAffiliation">
          <el-input
            v-model="author.authorAffiliation"
            :placeholder="$t('preprint.submitAuthor.affiliationPlaceholder')"
            size="medium"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('preprint.submitAuthor.correspondingLabel')" prop="isCorresponding">
          <el-switch
            class="switch"
            v-model="author.isCorresponding"
            active-color="#054a48"
            inactive-color="#E0E0F5"
            :active-text="$t('preprint.submitAuthor.correspondingYes')"
            :inactive-text="$t('preprint.submitAuthor.correspondingNo')"
          >
          </el-switch>
          <el-button
            icon="el-icon-delete"
            size="mini"
            @click.prevent="removeAuthor(index)"
            class="delete"
            v-if="authors.length > 1"
          >
            {{ $t('preprint.submitAuthor.deleteButton') }}
          </el-button>
        </el-form-item>
      </el-form>

      <el-row></el-row>
      <br />
      <el-col class="h4">
        <el-button @click="addAuthor()" class="ts">{{ $t('preprint.submitAuthor.addAuthorButton') }}</el-button>
        <el-button class="save" @click="saveAuthors">{{ $t('preprint.submitAuthor.saveButton') }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'PreprintAuthorComponent',
  data() {
    return {
      userInfo: null,
      authors: [
        {
          authorName: '',
          authorEmail: '',
          authorAffiliation: '',
          authorOrder: 1,
          isCorresponding: false
        }
      ]
    }
  },
  methods: {
    saveAuthors() {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

      for (let index = 0; index < this.authors.length; index++) {
        const author = this.authors[index]

        if (!author.authorName) {
          this.$message.warning(this.$t('preprint.submitAuthor.nameRequired', { index: index + 1 }))
          return
        }
        if (!author.authorEmail) {
          this.$message.warning(this.$t('preprint.submitAuthor.emailRequired', { index: index + 1 }))
          return
        }
        if (!emailRegex.test(author.authorEmail)) {
          this.$message.warning(this.$t('preprint.submitAuthor.emailInvalid', { index: index + 1 }))
          return
        }
        if (!author.authorAffiliation) {
          this.$message.warning(this.$t('preprint.submitAuthor.affiliationRequired', { index: index + 1 }))
          return
        }

        // 更新作者顺序
        author.authorOrder = index + 1
      }

      // 保存到全局状态
      this.$root.$emit('savePreprintAuthors', this.authors)
      this.$message.success(this.$t('preprint.submitAuthor.saveSuccess'))
    },
    removeAuthor(index) {
      if (this.authors.length > 1) {
        this.authors.splice(index, 1)
      }
    },
    addAuthor() {
      this.authors.push({
        authorName: '',
        authorEmail: '',
        authorAffiliation: '',
        authorOrder: this.authors.length + 1,
        isCorresponding: false
      })
    },
    loadSavedAuthors() {
      const saved = sessionStorage.getItem('preprintAuthors')
      if (saved) {
        this.authors = JSON.parse(saved)
      }
    }
  },
  mounted() {
    this.userInfo = this.$cookie.getCookie('userInfo')
    this.loadSavedAuthors()

    // 监听保存事件
    this.$root.$on('savePreprintAuthors', (authors) => {
      sessionStorage.setItem('preprintAuthors', JSON.stringify(authors))
    })

    // 监听加载预印本数据事件（重新提交模式）
    this.$root.$on('loadPreprintData', (data) => {
      console.log('=== preprintAuthorComponent 接收到数据 ===')
      console.log('接收到的数据:', data)
      console.log('作者数据:', data ? data.authors : null)
      
      if (data && data.authors && data.authors.length > 0) {
        this.authors = data.authors.map((author, index) => ({
          authorName: author.authorName || '',
          authorEmail: author.authorEmail || '',
          authorAffiliation: author.authorAffiliation || '',
          authorOrder: index + 1,
          isCorresponding: author.isCorresponding || false
        }))
        console.log('处理后的作者数据:', this.authors)
        // 同时保存到 sessionStorage
        sessionStorage.setItem('preprintAuthors', JSON.stringify(this.authors))
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('savePreprintAuthors')
    this.$root.$off('loadPreprintData')
  }
}
</script>

<style scoped>
.h4 {
  text-align: left;
  margin-left: 20px;
}

.switch {
  float: left;
  margin-left: 10px;
  margin-top: 10px;
}

.delete {
  float: right;
  margin-right: 10px;
  background-color: #fd7f48;
  color: white;
  border: none;
}

.ts {
  width: 150px;
  border-color: #12696e;
  border-width: 1px;
  border-radius: 0px;
}

.save {
  background-color: #054a48;
  color: white;
  width: 150px;
  border: none;
  border-radius: 0px;
}

button:hover {
  background-color: #0a696f;
  color: white;
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/preprint/preprintAuthorComponent.vue